<template>
  <div class="block-label">
    {{ label }}
  </div>
</template>
<script>
export default {
  props: ['label'],
}
</script>
<style scoped>
.block-label {
  width: 100%;
  margin-bottom: 5px;
  background-color: #333333;
  color: white;
  padding: 5px;
}
</style>
